import React from "react";

const Position = (props) => {
    return (
        <div className='input-details'>
            <input style={props.positionStyleObj}
                value={props.position}    
            />
        </div>
    )};

export default Position;
